import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=0b06b994&scoped=true&"
import script from "./EmailModal.vue?vue&type=script&lang=js&"
export * from "./EmailModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailModal.vue?vue&type=style&index=0&id=0b06b994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06b994",
  null
  
)

export default component.exports